import {Button, type ButtonProps} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import type React from 'react';
import {useMediaQuery} from '../../services/useMediaQuery';
import {ShareButtonMenu} from './menu';

type Props = ButtonProps & {
  url: string;
  title: string;
};

export const ShareButton: React.FC<Props> = ({
  url,
  title,
  children,
  ...rest
}) => {
  const [opened, {open, close}] = useDisclosure(false);
  const {isPC} = useMediaQuery();

  const handleShareClick = async () => {
    if (navigator.share && !isPC) {
      try {
        await navigator.share({
          title,
          text: title,
          url,
        });
      } catch (error) {
        console.error('共有に失敗しました', error);
      }
    } else {
      open();
    }
  };

  return (
    <>
      <ShareButtonMenu
        opened={opened}
        close={close}
        currentUrl={url}
        title={title}
      />
      <Button {...rest} onClick={handleShareClick}>
        {children}
      </Button>
    </>
  );
};
